import { FC } from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useMediaQuery, useTheme } from "@mui/material";

import Heading from "sections/nfcTagsPage/Heading";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import styles from "./styles";

const Ecosystem: FC = () => {
  const ITEMS = [
    {
      title: "SMART NFC LABELS",
      description:
        "Just one tap gives customers access to product info, care instructions, and digital experiences. Seamless, simple, and built into the garment.",
      imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/lp/ecosystem/image_2025-06-04_11-08-30.png`,
      buttonText: "See more",
    },
    {
      title: "LOYALTY & GAMIFICATION",
      description:
        "Turn your products into loyalty tools with interactive challenges and rewards. Boost retention through fun, branded engagement.",
      imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/lp/ecosystem/Nagłówek.png`,
      buttonText: "See more",
    },
    {
      title: "USER DATA COLLECTION",
      description:
        "Gain insights into who owns and interacts with your products. Use real-world data to improve marketing and design decisions.",
      imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/lp/ecosystem/dub.png`,
      buttonText: "See more",
    },
    {
      title: "DYNAMIC CONTENT",
      description:
        "Change what the user sees anytime: even after purchase. Push new campaigns, content, or updates instantly through the tag.",
      imageUrl: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/lp/ecosystem/n1.png`,
      buttonText: "See more",
    },
  ];

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box sx={{ mb: { xs: 4, md: 10, lg: 14 } }}>
      <Heading heading="Enhance Your Brand with Digital Tools" />

      <GridContainer spacing={0}>
        {ITEMS.map((item, i) => (
          <GridItem
            xs={12}
            md={6}
            lg={3}
            key={`${i}-item`}
            rowSpacing={4}
            sx={styles.itemWrapper}
          >
            <Box position="relative">
              <Box sx={(theme) => styles.box(theme, item.imageUrl)}>
                <Typography variant="h2" component="h3" sx={styles.title}>
                  {item.title}
                </Typography>

                {isDesktop && (
                  <Box
                    sx={styles.descriptionDesktop}
                    className="description-desktop"
                  >
                    <Typography paragraph mb={8}>
                      {item.description}
                    </Typography>
                    {
                      item.buttonText && null
                      // <CustomButton sx={{ ml: "auto" }}>
                      //   {item.buttonText}
                      //   <EastIcon sx={{ ml: 1 }} />
                      // </CustomButton>
                    }
                  </Box>
                )}
              </Box>
              {!isDesktop && (
                <Box sx={{ mb: 8, mt: 4 }}>
                  <Typography paragraph>{item.description}</Typography>
                  <Box display="flex" justifyContent="end">
                    {
                      item.buttonText && null
                      // <CustomButton sx={{ width: { xs: "auto" } }}>
                      //   {item.buttonText}
                      //   <EastIcon sx={{ ml: 1 }} />
                      // </CustomButton>
                    }
                  </Box>
                </Box>
              )}
            </Box>
          </GridItem>
        ))}
      </GridContainer>
    </Box>
  );
};

export default Ecosystem;
